export default __webpack_public_path__ + "static/media/hotel_overseas_4.9d576f06.jpg";